export default __webpack_public_path__ + "static/media/cyd_video_3.95682b73.mp4";